import { createContext } from 'react';

export const Web3DevHubContext = createContext(null);
